import { CSSProperties } from 'react';
import { theme } from '../../theme';

const font = theme.typography.fontFamily;

export const paymentFailurePanelStyles = {
  panel: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.medium,
    padding: `${theme.spacing.extraLarge}px ${theme.spacing.large}px`,
    backgroundColor: theme.colors.white,
    border: `1px solid #E8E8E8`,
    borderRadius: theme.radius.md,
  } as CSSProperties,

  iconWrapper: {
    marginTop: theme.spacing.small,
  } as CSSProperties,

  title: {
    margin: 0,
    maxWidth: 420,
    textAlign: 'center',
    color: theme.colors.palette.darkGrey200,
    fontFamily: font,
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: theme.typography.lineHeight.lg,
  } as CSSProperties,

  body: {
    margin: 0,
    maxWidth: 420,
    textAlign: 'center',
    color: theme.colors.label,
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  hint: {
    margin: 0,
    maxWidth: 420,
    textAlign: 'center',
    color: theme.colors.palette.darkGrey100 ?? theme.colors.label,
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  actionButton: {
    marginTop: theme.spacing.small,
    width: '100%',
    maxWidth: 320,
    boxSizing: 'border-box',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    border: `2px solid ${theme.colors.button.primary}`,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.white,
    color: theme.colors.button.primary,
    fontFamily: font,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,
};
